<template>
    <div class="RiskMannFooterEmpresas">
        <div class="offcanvas offcanvas-bottom rounded" tabindex="-1" id="empresasFooter" aria-labelledby="empresasFooterLabel">
            <div class="offcanvas-header">

                <h5 class="offcanvas-title fw-bold" id="empresasFooterLabel">Espacios de Trabajo Disponibles</h5>
                <button id="btnFooterEmpresasCerrar" type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>

            </div>
            <div class="offcanvas-body justify-content-start mb-3">
                <ListaEmpresas />
            </div>
        </div>
    </div>
</template>

<script>
import ListaEmpresas from './ListaEmpresas.vue';
export default {
    name: "RiskMannFooterEmpresas",

    components: {
        ListaEmpresas
    },

    mounted() {
        document.getElementById('empresasFooter').addEventListener('hidden.bs.offcanvas', event => {
            this.$emit("mostrar", false);
        })
    }
}
</script>

<style scoped>
.offcanvas-bottom {
    height: 500px;
}

.offcanvas-body {
    overflow-y: hidden;
}
</style>